
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { CustomFormFieldSubmission } from '@core/objects/form';

// import { User } from '@core/objects/user';

@Component({
    selector: 'form-field-view-user-selector-v1',
    templateUrl: './view-user-selector-v1.component.html'
})
export class ViewUserSelectorV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;


    ngOnInit(): void {
       
    }

}
